<template>
    <m-filter :text="text" :popup.sync="popup" :filtered="filtered">
        <ul class="list-none overflow-scroll" style="max-height: 180px">
            <li class="p-1 pl-8 cursor-pointer hover_bg-primary-200" @click="select(null)">None</li>
            <li class="p-1 pl-8 cursor-pointer hover_bg-primary-200" v-for="(item, index) in enumList"
                :key="item.id"
                :class="{'bg-primary-200': value && value.id == item.id}"
                @click="select(item)">{{ item.value }}</li>
        </ul>
    </m-filter>
</template>

<script>
export default {
    props: {
        value: Object,
        text: String,
        options: Object
    },
    data() {
        return {
            popup: false
        }
    },
    computed: {
        enumList() {
            // Convert options object to array of {id, value}
            return Object.entries(this.options || {}).map(([id, value]) => ({ id, value }));
        },
        filtered() {
            if (!this.value) return '';
            return this.value.value;
        }
    },
    methods: {
        select(item) {
            this.$emit('input', item);
            this.popup = false;
        }
    }
};
</script>
